import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

import classes from "./printInventory.module.scss";
import { ReactComponent as PrintIcon } from "@/assets/images/icons/Inventory/printer.svg";

import { formatMiles } from "@/services/Utils";

const PrintLotsTagNew = ({ handlePrint, handlePrintRowLot }) => {
	const { lots_available } = useSelector((state) => state.inventory);

	return (
		<>
			<Row>
				<Col xs={12} md={12} className={classes.scrollDivTable}>
					<table className={classes.tableSimple}>
						<thead>
							<tr>
								<th>Código Lote</th>
								<th>Producto</th>
								<th>N° Factura</th>
								<th>Cant. Envases</th>
							</tr>
						</thead>
						<tbody>
							{lots_available.map((lot, i) => {
								return (
									<tr key={i}>
										<td>{`L${lot.code}`}</td>
										<td>{lot.tradename}</td>
										<td>{lot.dealer_number}</td>
										<td>{formatMiles(lot.quantity_inventories)}</td>
										<td>
											<div
												style={{
													color: "white",
													background: "#8ac24e",
													borderRadius: "10px",
													marginRight: "5px",
													cursor: "pointer",
												}}
												onClick={() => handlePrintRowLot(lot, i)}
											>
												Imprimir
											</div>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</Col>
			</Row>
			<Row>
				<Col xs={12} md={12}>
					<div className={`${classes.selecttags} ${classes.active}`} onClick={(_e) => handlePrint("lots")}>
						<PrintIcon className={classes.icon} />
						<span className={classes.title}>Imprimir Lotes Nuevos</span>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default PrintLotsTagNew;
